// Instructions:
// using 'find and replace' change all *** Community *** to the first entity of the relationship in PascalCase
// using 'find and replace' change all *** SubCommunity *** to the second entity of the relationship in PascalCase
// using 'find and replace' change all *** community *** to the first entity of the relationship in camelCase
// using 'find and replace' change all *** subCommunity *** to the second entity of the relationship in camelCase

import { Team } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { SubTeamEntityConfig } from "./config";
import { SubTeamFilters } from "./filters";
import { SubTeamMethods } from "./methods";

@HyperEntity("sub-team", SubTeamEntityConfig)
export class SubTeam extends extender(SubTeamFilters, SubTeamMethods) {
  @Fields.string({
    dbName: "team_id",
  })
  teamId = "";

  @Fields.string({
    dbName: "sub_team_id",
  })
  subTeamId = "";

  @Relations.toOne<SubTeam, Team>(() => Team, {
    field: "teamId",
  })
  team?: Team;

  @Relations.toOne<SubTeam, Team>(() => Team, {
    field: "subTeamId",
    defaultIncluded: true,
  })
  subTeam?: Team;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
